import * as React from 'react';
var TableContext = React.createContext(null);
export default TableContext;